import SearchIcon from "@/SvgIcons/SearchIcon";
import React, { useState, useTransition, useCallback, useMemo } from "react";
import styles from "./desktop-program.module.scss";
import { SearchViewContainer } from "../../HeaderShared/SearchViewContainer";
const DProgramSearcher = ({ setIsMenuOpen, headerMenuList, popularCourses, newLaunches, associatedPrograms }) => {
  const { MAIN_LIST } = headerMenuList;
  const { Certifications } = headerMenuList.PROGRAM_WISE;
  const [isDashboardHidden, setIsDashboardHidden] = useState(true);
  const [hasOpened, setHasOpened] = useState(false);
  const [, startTransition] = useTransition();
  const newProgramList = useMemo(() => [...MAIN_LIST, ...Certifications], [MAIN_LIST, Certifications]);

  const toggleSearchDashboard = useCallback(() => {
    startTransition(() => {
      setIsDashboardHidden((prev) => !prev);
    });
  }, []);

  const openSearchViewContainer = useCallback(() => {
    if (!hasOpened) setHasOpened(true);
    startTransition(() => {
      setIsDashboardHidden(false);
    });
  }, [hasOpened]);

  return (
    <div className={styles.dProgramClosedSearchWrapper} >
      <div onClick={openSearchViewContainer} className={styles.dProgramClosedIcon}>
         <SearchIcon className={styles.dSearchIcon} color="#fff" />
      </div>

      {hasOpened && (
        <SearchViewContainer
          isDashboardHidden={isDashboardHidden}
          toggleSearchDashboard={toggleSearchDashboard}
          newLaunches={newLaunches}
          newProgramList={newProgramList}
          popularCourses={popularCourses}
          associatedPrograms={associatedPrograms}
        />
      )}
    </div>
  );
};

export default DProgramSearcher;
